module.exports = __webpack_public_path__ + "media/images/qr-code-1fe606f233e5a83818b64668b87b25cb.png";